import { Row } from 'antd'
// import { TbArrowBigDown } from 'react-icons/tb';


const Widget = (props) => {
    const { children, boxShadowColor, backgroundImage } = props
    return (
        <div style={{
            position: 'relative',
            height: 155,
            borderRadius: "10px",
            background: `var(--color-white)`,
            padding: 20,
            boxShadow: `0px 3px 16px ${boxShadowColor}`,

        }}>
            <div style={{ width: '100%', height: '100%', position: 'absolute', left: 0, top: 0 }}>
                <img style={{ width: '100%', height: '100%', borderRadius: "10px", }} src={backgroundImage} alt="" />
            </div>
            <Row align='middle' style={{ height: '100%' }} >
                {children}
            </Row>

        </div>
    )
}

export default Widget